<template>
  <el-select
    v-model.number="valueBackup"
    :placeholder="placeHolderBackup"
    filterable
    :clearable="clearable"
    :remote="remote"
    :remote-method="search"
  >
    <v-avatar-option :value="listBackup" :disabledId="disabledId"/>
  </el-select>
</template>

<script>
import { index } from "@/api/teacher";

export default {
  props: {
    value: [Number, String],
    storeId: [Number, String],
    disabledId: Array,
    list: Array,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    remote: Boolean,
  },
  data: () => ({
    valueBackup: '',
    placeHolderBackup: '',
    listBackup: [],
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;

      this.$emit('input', valueBackup);
      for (let i = 0; i < this.listBackup.length; i++) {
        if (valueBackup === this.listBackup[i].id) {
          return this.$emit('change', this.listBackup[i]);
        }
      }
    },
    list(list) {
      if (JSON.stringify(list) === JSON.stringify(this.listBackup)) return;
      this.listBackup = list;
    },
  },
  methods: {
    async search(keyword) {
      const { isError, data } = await index({
        store_id: keyword ? 0 : this.storeId,
        keyword: keyword || '',
        is_brief: 1,
      });
      if (!isError) this.listBackup = data || [];
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.placeHolderBackup = this.placeholder || '';

    if (this.list.length) this.listBackup = this.list;
  },
};
</script>
